import React from 'react';

/**
 * Iter-299e — Public SMS Terms & Conditions.
 *
 * Linked from the Register page SMS opt-in checkbox. Twilio's A2P
 * CTA review requires the SMS-specific T&C be public and reachable
 * from the opt-in flow. Treat the language below as a placeholder
 * until counsel ships V2; the structure (sections, frequency, rates,
 * STOP/HELP) is what Twilio actually checks for.
 */
const SmsTermsPage = () => {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-200 px-4 py-12">
      <div className="max-w-3xl mx-auto space-y-6" data-testid="sms-terms-page">
        <h1 className="text-3xl font-bold text-white">iEvntür SMS Terms &amp; Conditions</h1>
        <p className="text-zinc-400 text-sm">Effective 2026-06-30 · v1</p>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold text-white">1. What you&apos;ll receive</h2>
          <p>
            By opting in, you agree to receive SMS text messages from iEvntür
            about account verification, booking confirmations, shift reminders,
            schedule changes, payment notifications, job opportunities, and
            other account-related updates.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold text-white">2. Frequency</h2>
          <p>
            Message frequency varies based on your activity on the platform.
            Active talent and clients can expect 1–10 messages per booking;
            inactive accounts receive 0–2 messages per month.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold text-white">3. Cost</h2>
          <p>
            Message and data rates may apply. iEvntür does not charge for SMS;
            standard carrier fees from your wireless provider may apply.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold text-white">4. Opt-out</h2>
          <p>
            You can opt out at any time by replying <strong>STOP</strong> to
            any iEvntür message, or by toggling SMS off in your Notification
            Preferences. After opt-out we will only message you with critical
            account-security alerts you cannot disable.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold text-white">5. Help</h2>
          <p>
            Reply <strong>HELP</strong> to any iEvntür message to receive our
            support contact. You can also email{' '}
            <a href="mailto:support@ievntur.com" className="text-amber-400 underline">
              support@ievntur.com
            </a>.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold text-white">6. Privacy</h2>
          <p>
            We will never share or sell your mobile phone number or SMS opt-in
            data with third parties for marketing purposes. See our Privacy
            Policy for full data-handling terms.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold text-white">7. Carrier disclaimer</h2>
          <p>
            Carriers are not liable for delayed or undelivered messages.
            Supported carriers include AT&amp;T, Verizon, T-Mobile, Sprint,
            and most regional and prepaid carriers.
          </p>
        </section>
      </div>
    </div>
  );
};

export default SmsTermsPage;
